import React from 'react'
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'
import Moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ViewSurvey from './ViewSurvey'
import DetailSurvey from './DetailSurvey'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchSurvey,
    errorSurvey,

    fetchSurveyDetail,
    errorSurveyDetail,
    fetchSurveysList,
    fetchSurveyError,
    export_excel_surveys,
    export_excel_individual_survey

} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './Surveys.css'

var Spinner = require('react-spinkit');

let chkReturn = 0;

class Surveys extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            viewSurveyMode: false,
            detailSurveyMode: false,
            detailSurveyExtra: false,
            sortBy: 'surveyNumber',
            sortOrder: 'Ascending',
            survey_entry: "",
            progress: this.props.surveys.percent_complete,
            percentage: 0,
            value: -1,
            startDate: props.surveys.surveys.startDate,
            endDate: props.surveys.surveys.endDate,
            complete: false
        };

        this.fetchSurveyErrorClear = this.fetchSurveyErrorClear.bind(this);
        this.errorSurveyClear = this.errorSurveyClear.bind(this);
        this.errorSurveyDetailClear = this.errorSurveyDetailClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.changeStartDate = this.changeStartDate.bind(this);
        this.changeEndDate = this.changeEndDate.bind(this);
        this.changeCategory = this.changeCategory.bind(this);

        this.surveyView = this.surveyView.bind(this);
        this.surveyViewVerify = this.surveyViewVerify.bind(this);
        this.cancelSurvey = this.cancelSurvey.bind(this);
        this.surveyExport = this.surveyExport.bind(this);
        this.surveyDetail = this.surveyDetail.bind(this);
        this.surveyDetailVerify = this.surveyDetailVerify.bind(this);
        this.cancelSurveyDetail = this.cancelSurveyDetail.bind(this);
        this.individualSurveyExport = this.individualSurveyExport.bind(this);

        this.sortColumn = this.sortColumn.bind(this);
    }

    componentDidMount(prevProps, prevState) {
        if (window.location.pathname.toLowerCase() !== '/prod-mgmt/surveyslist') {
            let pathParts = window.location.pathname.split('/')
            let id = pathParts[pathParts.length - 1]

            this.setState({ detailSurveyExtra: true })

            fetchSurveyDetail.bind(this)({ susurvey: id });

            chkReturn = setInterval(this.surveyDetailVerify, 1000);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.surveys.surveys.startDate !== prevProps.surveys.surveys.startDate) {
            this.setState({
                startDate: this.props.surveys.surveys.startDate
            });
        }

        if (this.props.surveys.surveys.endDate !== prevProps.surveys.surveys.endDate) {
            this.setState({
                endDate: this.props.surveys.surveys.endDate
            });
        }

        if (this.state.startDate !== prevState.startDate || this.state.endDate !== prevState.endDate) {
            this.changeCategory();
        }
    }

    changeStartDate(date) {
        if (this.state.startDate !== date) {
            this.setState({
                startDate: Moment(date).format('YYYY-MM-DD')
            });
        }
    }

    changeEndDate(date) {
        if (this.state.endDate !== date) {
            this.setState({
                endDate: Moment(date).format('YYYY-MM-DD')
            });
        }
    }

    surveyExport(e) {
        let survey = {
            startDate: $('#startDate').val(),
            endDate: $('#endDate').val(),
            reportingCategory: $('#category').val(),
            selectedReportingCategory: this.state.survey_entry
        }

        if ($('#surveyType').val() != 'All')
            survey.surveyType = $('#surveyType').val()

        export_excel_surveys(this.props.dispatch, survey,  this.turn_off_progress_bar());
    }

    individualSurveyExport(e) {
        let survey = {
            susurvey: document.getElementById("detailSurveyNumber").innerHTML
        }
        export_excel_individual_survey(this.props.dispatch, survey);
    }

    turn_off_progress_bar() {
        document.getElementById("progress_bar").display = "none";
    }

    fetchSurveyErrorClear() {
        this.props.dispatch(fetchSurveyError);
    }

    errorSurveyClear(e) {
        this.props.dispatch(errorSurvey);

        if (this.props.survey.error === "409") {
            let id = e.target.attributes.survey.value;

            fetchSurvey.bind(this)(id);
        }
    }

    errorSurveyDetailClear(e) {
        this.props.dispatch(errorSurveyDetail);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    changeCategory() {
        var error = false

        let surveys = {
            reportingCategory: $('#category').val(),
            category: $('#category option:selected').text()
        }

        if ($('#surveyType').val() != 'All')
            surveys.surveyType = $('#surveyType').val()

        if ($('#startDate').val() !== '') {
            $('#startDate').removeClass('error')
            surveys.startDate = $('#startDate').val()
        }
        else {
            $('#startDate').addClass('error')
            error = true
        }

        if ($('#endDate').val() !== '') {
            $('#endDate').removeClass('error')
            surveys.endDate = $('#endDate').val()
        }
        else {
            $('#endDate').addClass('error')
            error = true
        }

        if (!error) fetchSurveysList.bind(this)(surveys)
    }

    surveyView(e) {

        if (chkReturn || this.props.surveys.fetching) return;
        chkReturn = 1;

        let survey = {
            startDate: $('#startDate').val(),
            endDate: $('#endDate').val(),
            reportingCategory: $('#category').val(),
            selectedReportingCategory: e.target.attributes.survey.value
        }

        this.setState({ survey_entry: e.target.attributes.survey.value});

        if ($('#surveyType').val() != 'All')
            survey.surveyType = $('#surveyType').val()

        let start = survey.startDate.split(/[-/]/)
        let end = survey.endDate.split(/[-/]/)

        this.setState(
            {
                surveyHeader1: `Customer Survey Reporting - ${e.target.attributes.survey.value} Results`,
                surveyHeader2: `For Survey Type ${$('#surveyType').val()} and `,
                surveyHeader3: `Date Range (${start[1]}/${start[2]}/${start[0]} - ${end[1]}/${end[2]}/${end[0]})`
            }
        )

        fetchSurvey.bind(this)(survey);

        chkReturn = setInterval(this.surveyViewVerify, 100);
    }

    surveyViewVerify() {
        if (this.props.survey.fetched || this.props.survey.error) {
            if (this.props.survey.fetched) {
                this.setState({
                    viewSurveyMode: true
                });
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    cancelSurvey() {
        this.props.dispatch(errorSurvey);

        this.setState({
            viewSurveyMode: false
        });
    }

    surveyDetail(e) {

        if (chkReturn) return;
        chkReturn = 1;

        fetchSurveyDetail.bind(this)({ susurvey: e.target.attributes.survey.value });

        chkReturn = setInterval(this.surveyDetailVerify, 100);
    }

    surveyDetailVerify() {
        if (this.props.survey.fetchedDetail || this.props.survey.errorDetail) {
            if (this.props.survey.fetchedDetail) {
                this.setState({
                    detailSurveyMode: true
                });
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    cancelSurveyDetail() {
        this.props.dispatch(errorSurveyDetail);

        if (this.state.detailSurveyExtra) {
            this.setState({
                detailSurveyExtra: false
            })
            window.location.pathname = '/prod-mgmt/surveyslist'
        }
        else 
            this.setState({
                detailSurveyMode: false
            });
    }

    sortColumn(e) {
        let sortOrder
        let sortElement = e.target.children.length === 0 ? e.target.parentElement : e.target
        let sortBy = sortElement.id
        let sort = sortElement.children[0].className.split(' ')[1]

        if (sort === "fa-sort") {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }
        else if (sort === "fa-sort-asc") {
            sortOrder = "Descending"
            sortElement.children[0].className = "fa fa-sort-desc fa-xs"
        }
        else {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }

        this.setState(
            {
                sortBy: sortBy,
                sortOrder: sortOrder
            }
        );

        $('th').each(function () {
            if ($(this).attr('id') !== sortElement.id) {
                $(this).removeClass("sort")
                $($(this).children()[0]).removeClass("fa-sort-asc")
                $($(this).children()[0]).removeClass("fa-sort-desc")
                $($(this).children()[0]).addClass("fa-sort")
            }
        })

        sortElement.className = "sort"
    }

    render() {
        return (
            <div className="product-surveys col-xs-12">
                <CommError error={this.props.survey.error} onClose={this.errorSurveyClear} />
                <CommError error={this.props.surveys.error} onClose={this.fetchSurveyErrorClear} />

                <ConfirmModal open={this.props.surveys.noData} heading={"Customer Survey Reporting"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                {
                    !this.state.detailSurveyExtra ?
                        <div>
                            <div className="headWrapper">
                                <div className="productSurveys">
                                    <h1>Customer Survey Reporting</h1>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="col-md-3">
                                        <p>Start Date:</p>
                                        <DatePicker
                                            id="startDate"
                                            onSelect={this.changeCategory}
                                            onChange={this.changeStartDate}
                                            selected={Moment(this.state.startDate).toDate()}
                                            showYearDropdown
                                            dropdownMode="select"
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <p>End Date:</p>
                                        <DatePicker
                                            id="endDate"
                                            onSelect={this.changeCategory}
                                            onChange={this.changeEndDate}
                                            selected={Moment(this.state.endDate).toDate()}
                                            showYearDropdown
                                            dropdownMode="select"
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <p>Reporting Category:</p>
                                        {
                                            this.props.surveys.fetching ?
                                                <select id="category" defaultValue={"reico_company_score"} disabled >
                                                    <option value="appliance_manufacturer">Appliance Manufacturer</option>
                                                    <option value="cabinet_manufacturer">Cabinet Manufacturers</option>
                                                    <option value="counter_top">Countertop Types</option>
                                                    <option value="designer">Designer</option>
                                                    <option value="contractor">Contractor</option>
                                                    <option value="location">Location</option>
                                                    <option value="reico_company_score">Reico Company Scores</option>
                                                </select>
                                            :
                                                <select id="category" defaultValue={"reico_company_score"} onChange={this.changeCategory}>
                                                    <option value="appliance_manufacturer">Appliance Manufacturer</option>
                                                    <option value="cabinet_manufacturer">Cabinet Manufacturers</option>
                                                    <option value="counter_top">Countertop Types</option>
                                                    <option value="designer">Designer</option>
                                                    <option value="contractor">Contractor</option>
                                                    <option value="location">Location</option>
                                                    <option value="reico_company_score">Reico Company Scores</option>
                                                </select>
                                        }
                                    </div>
                                    <div className="col-md-3">
                                        <p>Survey Type:</p>
                                        {
                                            this.props.surveys.fetching ?
                                                <select id="surveyType" disabled>
                                                    <option value="All">All</option>
                                                    <option value="Retail">Retail</option>
                                                    <option value="Contractor">Contractor</option>
                                                </select>
                                            :
                                                <select id="surveyType" onChange={this.changeCategory}>
                                                    <option value="All">All</option>
                                                    <option value="Retail">Retail</option>
                                                    <option value="Contractor">Contractor</option>
                                                </select>
                                        }
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="tableWrapper">
                                        {
                                            this.props.surveys.fetching ?
                                                <Spinner name='line-spin-fade-loader' />
                                            :
                                                null
                                        }
                                        <table className="lists table table-striped">
                                            <thead>
                                                <tr className="head">
                                                    <th className="type">{this.props.surveys.surveys.category}</th>
                                                    <th>Score</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.props.surveysList ? this.props.surveysList.map((survey, index) => {
                                                        return <tr key={index}>
                                                            <td className="survey_name" survey={survey.field_name} onClick={this.surveyView}>{survey.field_name}</td>
                                                            <td>{survey.average_score}</td>
                                                        </tr>
                                                    }) : null
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {
                                    this.props.surveys.surveys.category == 'Reico Company Scores' ?
                                        <div className="col-md-3">
                                            <table className="totals">
                                                <tbody>
                                                    <tr>
                                                        <td>Total Surveys Sent:</td>
                                                        <td>{this.props.surveys.surveysList.totalSurveysSent}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Survey Response Rate:</td>
                                                        <td>{((this.props.surveys.surveysList.totalResponses / this.props.surveys.surveysList.totalSurveysSent) * 100).toFixed(2)}%</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    : null
                                }
                            </div>
                        </div>
                    : null
                }

                {
                    this.props.survey.fetched ?
                        <ViewSurvey
                            errSurvey={this.props.survey}
                            errSurveyClear={this.errorSurveyClear}
                            errSurveyDetailClear={this.errorSurveyDetailClear}

                            header1={this.state.surveyHeader1}
                            header2={this.state.surveyHeader2}
                            header3={this.state.surveyHeader3}

                            curSurvey={this.props.survey.survey}

                            sortBy={this.state.sortBy}
                            sortOrder={this.state.sortOrder}
                            sortColumn={this.sortColumn}

                            isOpen={this.state.viewSurveyMode}

                            surveyDetail={this.surveyDetail}
                            surveyExport={this.surveyExport}
                            surveyExportDetails={this.props.survey}
                            onRequestCancel={this.cancelSurvey}
                        />
                    : null
                }

                {
                    this.props.survey.fetchedDetail ?
                        <DetailSurvey
                            errDetail={this.props.survey}
                            errDetailClear={this.errorSurveyDetailClear}

                            curDetail={this.props.survey.detail}

                            surveyDetail={this.surveyDetail}
                            surveyDetailExportInformation={this.individualSurveyExport}
                            detailExportDetails={this.props.survey}
                            isOpen={this.state.detailSurveyMode}

                            onRequestCancel={this.cancelSurveyDetail}
                        />
                    : null
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    survey: state.survey,
    surveys: state.surveys
});

export default connect(mapStateToProps)(Surveys)